import { useEffect } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import useRouteAccess from '../hooks/access/useRouteAccess';
import UnauthorizedPage from '../auth/pages/UnauthorizedPage';
import LoadingOverlay from '../components/Loading/LoadingOverlay';

const ProtectedRouteV2: React.FC = () => {
  const { pathname } = useLocation();
  const { checkAccess, allowed, lastCheckedRoute } = useRouteAccess();
  const auth = useSelector((state: RootState) => state.auth);

  const ignoredRoutes = ['/', '/dashboard', '/dashboard/general'];

  const normalizePath = (path: string): string => {
    let cleanPath = path.split('?')[0].split('#')[0];

    // /ruta/1/edit => /ruta
    cleanPath = cleanPath.replace(/\/\d+\/edit$/, '');

    // /ruta/uuid/edit => /ruta
    cleanPath = cleanPath.replace(
      /\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/edit$/i,
      ''
    );

    // /ruta/page/1 => /ruta
    cleanPath = cleanPath.replace(/\/page\/\d+$/, '');

    // /ruta/1 => /ruta
    cleanPath = cleanPath.replace(/\/\d+$/, '');

    // /ruta/uuid => /ruta
    cleanPath = cleanPath.replace(
      /\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
      ''
    );

    return cleanPath;
  };

  useEffect(() => {
    if (!auth.isAuthenticated || !auth.accessToken) return;

    const cleanPath = normalizePath(pathname);
    if (ignoredRoutes.includes(cleanPath)) return;

    if (lastCheckedRoute !== cleanPath) {
      checkAccess(cleanPath);
    }
  }, [
    pathname,
    auth.isAuthenticated,
    auth.accessToken,
    lastCheckedRoute,
    checkAccess,
  ]);

  const cleanPath = normalizePath(pathname);

  const isChecking =
    auth.isAuthenticated &&
    !ignoredRoutes.includes(cleanPath) &&
    (allowed === undefined || lastCheckedRoute !== cleanPath);

  if (!auth.isAuthenticated) {
    return <UnauthorizedPage />;
  }

  return isChecking ? (
    <LoadingOverlay />
  ) : allowed === false ? (
    <UnauthorizedPage />
  ) : (
    <Outlet />
  );
};

export default ProtectedRouteV2;